import { SVG, SVGProps } from './svg'

export function IconToolExpand(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M24.5 27.91a.3.3 0 0 1-.3-.29v-.16c0-.08.04-.16.1-.21l2.95-2.96a.29.29 0 0 1 .2-.08h.17a.3.3 0 0 1 .3.29v3.12a.28.28 0 0 1-.3.3H24.5Z"
      />
    </SVG>
  )
}
